import { render, staticRenderFns } from "./c_data_management_home.vue?vue&type=template&id=6c2b30be&scoped=true"
import script from "./c_data_management_home.vue?vue&type=script&lang=js"
export * from "./c_data_management_home.vue?vue&type=script&lang=js"
import style0 from "./c_data_management_home.vue?vue&type=style&index=0&id=6c2b30be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2b30be",
  null
  
)

export default component.exports